import { useState, useRef, useEffect, useMemo } from 'react';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';
import CardLayout from '../../../components/utils/CardLayout';
import { useForm } from "react-hook-form";
import moment from "moment";
import DatePicker from "react-datepicker";
import Calendar2LineIcon from 'remixicon-react/Calendar2LineIcon';
import { useDispatch, useSelector } from 'react-redux';
import DownloadCloud2sLineIcon from 'remixicon-react/DownloadCloud2LineIcon';
import shortCodeActions from '../../../redux/shortCodeData/actions'
import networkActions from '../../../redux/network/actions';
import authActions from '../../../redux/auth/actions';
import dealerAction from '../../../redux/dealer/actions'
import { isAdmin, isAdminAgent } from '../../../helpers/commonFunction';
import Button from '../../../components/utils/Button';
import SearchBar from '../../../components/utils/SearchBar';
import SideButtons from '../../../components/utils/SideButtons';
import Table from '../../../components/utils/Table'
import DailyPlanRequestForm from './DailyActsPlanForm'
import dailyPlanRequestActions from '../../../redux/dailyPlanRequest/actions'
import { convertDateToRequiredFormatTZ, convertDateTimeToRequiredFormatTZ } from '../../../helpers/commonFunction';
import Tag from '../../../components/utils/Tag';
import Alert from '../../../components/utils/Alert';
import CompleteDailyPlanRequest from './CompleteDailyPlanRequest'
import CancelDailyPlanRequest from './CancelDailyPlanRequest';
import BulkDailyPlanActivation from './BulkDailyPlanActivation';
import DailyPlanRefund from './DailyPlanRefund';
import DailyPlanExtend from './DailyPlanExtend';
import DailyPlanReduce from './DailyPlanReduce';
import DailyPlanRefundDetails from './DailyPlanRefundDetails';
import useSocket from '../../../hooks/useSocket';
import SocketActions from '../../../redux/socket/actions';
import momenttz from 'moment-timezone';
import PendingCountDealer from './PendingCountDealer';
import DailyPlanHistory from './DailyPlanHistory';

const DailyActsPlan = () => {
    const dispatch = useDispatch();
    const { getDailyPlanRequestListForSocket } = SocketActions;
    const { dailyRequestResult, dailyRequestListLoading, buttonLoading, dailyRequestMessage, Lockerror, Lockmessage, realselockerror, realselockmessage, lockLoading, releaselockloading, cancelmessage, completeDailyPlanRequestMessage, checkDailyPlanCompletionStatusMessage, createBulkActivationForDailyPlanMessage, createBulkActivationForDailyPlanError, createActivationForDailyPlanMessage, refundDailyPlanRequestMessage, extendDailyPlanRequestMessage, reduceDailyPlanRequestMessage } = useSelector((state) => state.dailyPlanRequest);
    const { getDailyPlanRequestList, prepareDailyPlanRequestModal, resetDailyPlan, unLockDailyPlanRequest, lockDailyPlanRequest, prepareCancelModal, resetCompleteForm } = dailyPlanRequestActions;
    const { getUserDataByToken } = authActions;
    const { getDealer } = dealerAction;
    const { getActiveNetworkDAilyPlanMapping } = networkActions;
    const { getShortCode } = shortCodeActions;
    const [filterText, setFilterText] = useState("");
    const { tokenData } = useSelector((state) => state.auth);
    const { shortCodeResult } = useSelector((state) => state.shortCode);
    const { networkResultData } = useSelector((state) => state.network);
    const dealerResult = useSelector((state) => state.dealer.dealerResult);
    const datePickerRef = useRef(null);
    const datePickerRef2 = useRef(null);
    const [toDate, setToDate] = useState(new Date())
    const [fromDate, setFromDate] = useState(new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000));
    const [searchData, setSearchData] = useState({
        statusID: '10',
        serialNumber: '',
        fromDate: moment(fromDate).format("YYYY-MM-DD"),
        toDate: moment(toDate).format("YYYY-MM-DD"),
        dealerID: "",
        networkID: ""
    });
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const [completeModal, setCompleteModal] = useState(false);
    const [row, setRow] = useState(new Object());
    const [selectedLockId, setSelectedLockId] = useState('');
    const [transactionID, setTransactionID] = useState(null);
    const [cancelID, setcancelID] = useState(null);
    const [dailyPlanRequestID, setdailyPlanRequestID] = useState(null);
    const [pageNumber, setPageNumber] = useState(0);
    const [refundModal, setRefundModal] = useState(false);
    const [refundInfoModal, setRefundInfoModal] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [extendModal, setExtendModal] = useState(false);
    const [hoveredId, setHoveredId] = useState(null);
    const [reduceModal, setReduceModal] = useState(false);
    const [historyModal, setHistoryModal] = useState(false);

    const handleCloseModal = () => {
        setCompleteModal(false);
    }

    const { register: registerFilter, handleSubmit: handleSubmit, formState: { errors: filterError }, watch, reset, getValues, setValue } = useForm({ defaultValues: searchData });

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const openDatePicker = () => {
        datePickerRef.current.setOpen(true);
    };
    const openDatePicker2 = () => {
        datePickerRef2.current.setOpen(true);
    };
    const handleFilterChange = (value) => {
        setFilterText(value);
    };

    const columns = [
        { displayName: '#', key: 'key' },
        { displayName: 'CREATION TIME', key: 'critionTime' },
        { displayName: 'DEALER', key: 'dealer' },
        { displayName: 'NETWORK', key: 'networkName' },
        { displayName: 'ACTION', key: 'action' },
        { displayName: 'STATUS', key: 'Status' },
        ...(isAdmin(tokenData) || isAdminAgent(tokenData) ? [{ displayName: 'ASSIGNED TO', key: 'AssignedTo' }] : []),
        { displayName: 'IMEI', key: 'IMEI' },
        { displayName: 'SERIAL NUMBER', key: 'SerialNumber' },
        { displayName: 'MSISDN', key: 'MSISDN' },
        { displayName: 'FROM DATE', key: 'RequestedDtTm' },
        { displayName: 'TO DATE', key: 'toDate' },
        { displayName: 'EXPIRY DATE', key: 'expiryDate' },
        { displayName: 'DAYS', key: 'days' },
        { displayName: 'SIM TYPE', key: 'simType' },
        { displayName: 'TRANSACTION ID', key: 'TransactionID' },
        { displayName: 'EMAIL', key: 'email' },
        { displayName: 'AMOUNT', key: 'amountCharged' },
        { displayName: 'ZIP CODE', key: 'areaCode' },
        { displayName: 'ADDON', key: 'addon' },
        { displayName: 'SOURCE', key: 'source' },
        ...(isAdmin(tokenData) || isAdminAgent(tokenData) ? [{ displayName: 'COMPLETED BY', key: 'completedBy' }] : []),
        { displayName: 'REMARK', key: 'Remark' },
    ];

    useSocket('lock daily plan request', () => {
        if (isAdmin(tokenData) || isAdminAgent(tokenData)) {
            dispatch(getDailyPlanRequestListForSocket(searchData));
            handleCloseModal();
        }
    });

    useSocket('reduce daily plan request', () => {
        if (isAdmin(tokenData) || isAdminAgent(tokenData)) {
            dispatch(getDailyPlanRequestListForSocket(searchData));
            closeReduceDaysModal();
        }
    });

    useEffect(() => {
        dispatch(getDealer());
        dispatch(getActiveNetworkDAilyPlanMapping());
        dispatch(getShortCode({
            tableName: "activationrequest",
            fieldName: "RequestStatus"
        }));

        dispatch(getDailyPlanRequestList(searchData))
        dispatch(resetDailyPlan());
    }, [])

    useEffect(() => {
        if (networkResultData.length === 1) {
            setValue('networkID', networkResultData[0].ID);
        }
    }, [networkResultData, setValue]);

    useEffect(() => {
        if (dailyRequestMessage !== null && dailyRequestMessage !== undefined) {
            displayAlert(dailyRequestMessage, 'alert-success');
        }
        if (Lockmessage !== null && Lockmessage !== undefined) {
            displayAlert(Lockmessage, 'alert-success');
        }
        if (Lockerror !== null && Lockerror !== undefined) {
            displayAlert(Lockerror, 'alert-danger');
        }
        if (realselockmessage !== null && realselockmessage !== undefined) {
            displayAlert(realselockmessage, 'alert-success');
        }
        if (realselockerror !== null && realselockerror !== undefined) {
            displayAlert(realselockerror, 'alert-danger');
        }
        if (cancelmessage !== null && cancelmessage !== undefined) {
            displayAlert(cancelmessage, 'alert-success');
        }
        if (completeDailyPlanRequestMessage !== null && completeDailyPlanRequestMessage !== undefined) {
            displayAlert(completeDailyPlanRequestMessage, 'alert-success');
        }
        if (checkDailyPlanCompletionStatusMessage !== null && checkDailyPlanCompletionStatusMessage !== undefined) {
            displayAlert(checkDailyPlanCompletionStatusMessage, 'alert-success');
        }
        if (createBulkActivationForDailyPlanMessage !== null && createBulkActivationForDailyPlanMessage !== undefined) {
            displayAlert(createBulkActivationForDailyPlanMessage, 'alert-success');
        }
        if (createBulkActivationForDailyPlanError !== null && createBulkActivationForDailyPlanError !== undefined) {
            displayAlert(createBulkActivationForDailyPlanError, 'alert-danger');
        }
        if (createActivationForDailyPlanMessage !== null && createActivationForDailyPlanMessage !== undefined) {
            displayAlert(createActivationForDailyPlanMessage, 'alert-success');
        }
        if (refundDailyPlanRequestMessage !== null && refundDailyPlanRequestMessage !== undefined) {
            displayAlert(refundDailyPlanRequestMessage, 'alert-success');
        }
        if (extendDailyPlanRequestMessage !== null && extendDailyPlanRequestMessage !== undefined) {
            displayAlert(extendDailyPlanRequestMessage, 'alert-success');
        }
        if (reduceDailyPlanRequestMessage !== null && reduceDailyPlanRequestMessage !== undefined) {
            displayAlert(reduceDailyPlanRequestMessage, 'alert-success');
        }

    }, [
        createBulkActivationForDailyPlanMessage,
        createBulkActivationForDailyPlanError,
        dailyRequestMessage,
        Lockmessage,
        Lockerror,
        realselockmessage,
        realselockerror,
        cancelmessage,
        completeDailyPlanRequestMessage,
        checkDailyPlanCompletionStatusMessage,
        createActivationForDailyPlanMessage,
        refundDailyPlanRequestMessage,
        extendDailyPlanRequestMessage,
        reduceDailyPlanRequestMessage
    ]);

    const handleOpenAddFormModal = () => {
        dispatch(prepareDailyPlanRequestModal());
    }
    const onSubmit = (data) => {
        const newData = {
            ...data,
            toDate: moment(new Date(toDate)).format("YYYY-MM-DD"),
            fromDate: moment(new Date(fromDate)).format("YYYY-MM-DD"),
        };
        setSearchData(newData)
        dispatch(getDailyPlanRequestList(newData));
    }

    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
        dispatch(resetDailyPlan());
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetDailyPlan());
    }

    const filteredItems = Array.isArray(dailyRequestResult) && dailyRequestResult.length > 0 ? dailyRequestResult.filter(item => {
        if (typeof filterText !== 'string' || typeof item !== 'object') return false;
        // Check if any value in the object contains the filterText
        return Object.values(item).some(value => typeof value === 'string' && value.toLowerCase().includes(filterText.toLowerCase()));
    }) : [];

    const handleCompleteForm = (row) => {
        dispatch(resetCompleteForm())
        let formData = getValues();
        const newData = {
            ...formData,
            toDate: moment(new Date(toDate)).format("YYYY-MM-DD"),
            fromDate: moment(new Date(fromDate)).format("YYYY-MM-DD"),
        };
        setSearchData(newData)
        setRow(row);
        setCompleteModal(true);
    }

    const handleCancelForm = (id, transactionID) => {
        dispatch(prepareCancelModal(id));
        setcancelID(id)
        setTransactionID(transactionID);
    };


    const handleLockDeailyPlan = (Id) => {
        let request = {
            activationId: Id
        }
        setdailyPlanRequestID(Id)
        dispatch(lockDailyPlanRequest(request, searchData))

    }

    const handleUnlockDeailyPlan = (Id) => {
        let request = {
            activationId: Id
        }
        setSelectedLockId(Id)
        dispatch(unLockDailyPlanRequest(request, searchData))
    }

    const openDailyPlanRefundModal = (row) => {
        let formData = getValues();
        const newData = {
            ...formData,
            toDate: moment(new Date(toDate)).format("YYYY-MM-DD"),
            fromDate: moment(new Date(fromDate)).format("YYYY-MM-DD"),
        };
        setSearchData(newData)
        setRow(row);
        setRefundModal(true);
    }

    const closeDailyPlanRefundModal = () => {
        setRefundModal(false);
    }

    const openShowRefundInfo = (row) => {
        setRow(row);
        setRefundInfoModal(true);
    }

    const closeShowRefundInfo = () => {
        setRefundInfoModal(false);
    }

    const openExtendDays = (row) => {
        setRow(row);
        setExtendModal(true);
    }

    const openReduceDays = (row) => {
        setRow(row);
        setReduceModal(true);
    }

    const closeExtendDaysModal = () => {
        setExtendModal(false);
    }

    const closeReduceDaysModal = () => {
        setReduceModal(false);
    }

    const openhistoryInfo = (row) => {
        setRow(row);
        setHistoryModal(true);
    }

    const closeHistoryModal = () => {
        setHistoryModal(false);
    }

    const data = useMemo(() => {
        if (filteredItems && filteredItems.length) {
            return filteredItems.map((item, key) => {
                let RequestedDtTm = moment(moment(item.RequestedDtTm).format('YYYY-MM-DD'));
                let currentDate = moment(moment().tz(process.env.REACT_APP_DISPLAY_TIMEZONE).format('YYYY-MM-DD'));
                let diffInDays = currentDate.diff(RequestedDtTm, 'days');
                let extendBtnVisible = currentDate.isSameOrBefore(moment(item.RequestedToDate), 'day') && moment(item.RequestedToDate).isBefore(moment(item.ExpiryDate), "day");
                let requestedPST = moment(item.RequestedToDate).tz(process.env.REACT_APP_TIMEZONE).format('YYYY-MM-DD');
                let refundBtnVisible = currentDate.isSameOrBefore(requestedPST, "day");
                let reduceBtnVisible = item.HoursDifference < 24 && item.RequestedDays > 4;
                return {
                    key: key + 1,
                    TransactionID: item.TransactionID,
                    SerialNumber: item.SerialNumber,
                    IMEI: item.IMEI,
                    MSISDN: item.RequestStatus === 12 ? item.MSISDN : '',
                    networkName: item.NetworkName,
                    simType: item.SimTypeValue,
                    email: item.CustomerEmailID,
                    areaCode: item.AreaCode,
                    dealer: item.DealerName,
                    amountCharged: `$${item.AmountCharged.toFixed(2)}`,
                    days: item.RequestedDays,
                    RequestedDtTm: item.RequestedDtTm !== null ? moment(item.RequestedDtTm, "YYYY-MM-DD").format(`${process.env.REACT_APP_DATE_FORMAT}`) : '',
                    toDate: item.RequestedToDate !== null ? moment(item.RequestedToDate, "YYYY-MM-DD").format(`${process.env.REACT_APP_DATE_FORMAT}`) : '',
                    Status: (
                        <Tag
                            color={(diffInDays < 0 && item.RequestStatus != 13) ? 'badge-info' : (item.ActivationID && item.RequestStatus === 10) ? 'badge-danger' : item.RequestStatus === 13 ? 'badge-danger' : item.RequestStatus === 11 ? 'badge-warning' : item.RequestStatus === 12 ? 'badge-success' : item.RequestStatus === 47 ? 'badge-secondary' : 'badge-secondary'}
                            title={diffInDays < 0 && item.RequestStatus != 13 ? 'Scheduled' : item.RequestStatusValue}
                        />),
                    Remark: item.Remark,
                    addon: item.ServiceName,
                    completedBy: item.CompletedByName,
                    source: item.ActivationSource,
                    critionTime: item.CreatedDtTm !== null ? moment(item.CreatedDtTm).tz(process.env.REACT_APP_TIMEZONE).format(process.env.REACT_APP_LONG_TIME_FORMAT) : '',
                    AssignedTo: (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', position: 'relative' }}>
                            {item.SimSwapID ? 'SIM Swap' : item.ActivationID ? 'Activation' : ''}

                            {item.RequestStatus === 10 && item.ActivationID && (
                                <div
                                    onMouseEnter={() => setHoveredId(item.ID)}
                                    onMouseLeave={() => setHoveredId(null)}
                                    style={{ position: 'relative', display: 'inline-block' }}
                                >
                                    <i class="ri-information-fill" style={{ color: "#294c28eb", cursor: 'pointer', fontSize: "1.2em" }} ></i>

                                    {hoveredId === item.ID && (
                                        <div
                                            style={{ position: 'absolute', bottom: '85%', left: '50%', transform: 'translateX(-3%)', background: 'black', color: '#fff', padding: '6px 5px', borderRadius: '6px', boxShadow: '0 2px 8px rgba(0,0,0,0.25)', fontSize: '14px', zIndex: 9999, textAlign: 'left', width: '300px', whiteSpace: 'pre-line', lineHeight: '1.3' }}
                                        >
                                            {item.ActivationRemark || 'No Remark Found'}
                                            <div
                                                style={{ position: 'absolute', top: '96%', left: '3%', transform: 'translateX(-50%)', width: 0, height: 0, borderLeft: '10px solid transparent', borderRight: '10px solid transparent', borderTop: '10px solid #fff', }}
                                            />
                                        </div>
                                    )}
                                </div>
                            )
                            }
                        </div >
                    ),
                    expiryDate: item.RequestStatus === 12 && item.ExpiryDate ? moment(item.ExpiryDate, "YYYY-MM-DD").format(process.env.REACT_APP_DATE_FORMAT) : '',
                    action:
                        <>
                            {(isAdmin(tokenData) || isAdminAgent(tokenData)) && (
                                item.RequestStatus === 10 && (
                                    item.lockFlag === 0 ? (
                                        item.lockFlag === 0 && item.otherLockFlag === 0 ?
                                            <div>
                                                {lockLoading && dailyPlanRequestID == item.ID ? <div style={{ marginLeft: "5px" }} class="spinner-border spinner-border-sm" role="status">
                                                    <span class="sr-only">Loading...</span>
                                                </div> : <div className="icon iq-action-icon-box rounded-circle" style={{ backgroundColor: 'purple' }} >
                                                    <span onClick={() => handleLockDeailyPlan(item.ID)}><i className="ri-lock-line" style={{ color: '#fff' }}></i></span>
                                                </div>}
                                            </div>
                                            :
                                            <>
                                                <div className="icon iq-action-icon-box rounded-circle bg-danger" onClick={() => setShowPopup(true)} style={{ cursor: "pointer" }} >
                                                    <i className="ri-spam-2-line"></i>
                                                </div>

                                                {/* Popup Modal */}
                                                {showPopup && (
                                                    <div style={overlayStyle}>
                                                        <div style={modalStyle}>
                                                            <h4>This transaction is locked by {item.LockedByName}</h4>
                                                            <button onClick={() => setShowPopup(false)} style={buttonStyle}> Close </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                    ) : (
                                        <div className='d-flex'>
                                            {
                                                diffInDays >= 0 &&
                                                <div className="icon iq-action-icon-box rounded-circle bg-success" onClick={() => handleCompleteForm(item)}>
                                                    <i className="ri-check-line"></i>
                                                </div>
                                            }
                                            <div className="icon iq-action-icon-box rounded-circle bg-danger" onClick={() => handleCancelForm(item.ID, item.TransactionID)}>
                                                <i className="ri-close-fill"></i>
                                            </div>
                                            {releaselockloading && dailyPlanRequestID == item.ID ? (
                                                <div style={{ marginTop: "5px" }} className="spinner-border spinner-border-sm" role="status"> <span className="sr-only">Loading...</span> </div>
                                            ) : (
                                                <div className="icon iq-action-icon-box rounded-circle bg-secondary" onClick={() => handleUnlockDeailyPlan(item.ID)}> <i className="ri-lock-unlock-line" style={{ color: '#fff' }}></i> </div>
                                            )}
                                        </div>
                                    )
                                )
                            )}
                            {
                                <div className='d-flex'>
                                    {
                                        (isAdmin(tokenData) || isAdminAgent(tokenData)) && item.RequestStatus === 12 && refundBtnVisible &&
                                        <div className="icon iq-action-icon-box rounded-circle" style={{ backgroundColor: '#8e44ad' }} >
                                            <span data-toggle="tooltip" data-placement="top" title="Refund" onClick={() => openDailyPlanRefundModal(item)}><i className="ri-money-dollar-circle-line" style={{ color: '#fff' }}></i></span>
                                        </div>
                                    }

                                    {
                                        (isAdmin(tokenData) || isAdminAgent(tokenData)) && item.RequestStatus === 12 && extendBtnVisible &&
                                        <div className="icon iq-action-icon-box rounded-circle" style={{ backgroundColor: '#16a085' }} >
                                            <span data-toggle="tooltip" data-placement="top" title="Extend" onClick={() => openExtendDays(item)}><i className="ri-calendar-line" style={{ color: '#fff' }}></i></span>
                                        </div>
                                    }

                                    {
                                        (isAdmin(tokenData) || isAdminAgent(tokenData)) && item.RequestStatus === 12 && reduceBtnVisible &&
                                        <div className="icon iq-action-icon-box rounded-circle" style={{ backgroundColor: '#e74c3c' }} >
                                            <span data-toggle="tooltip" data-placement="top" title="Reduce" onClick={() => openReduceDays(item)}><i className="ri-calendar-2-line" style={{ color: '#fff' }}></i></span>
                                        </div>
                                    }

                                    {
                                        item.RequestStatus === 47 &&
                                        <div>
                                            <div className="icon iq-action-icon-box rounded-circle" style={{ backgroundColor: '#3498db' }} >
                                                <span onClick={() => openShowRefundInfo(item)}><i className="ri-refund-line" style={{ color: '#fff' }}></i></span>
                                            </div>
                                        </div>
                                    }

                                    {
                                        (isAdmin(tokenData) || isAdminAgent(tokenData)) && item.RequestStatus === 12 && item.isExtendOrReduceEntry === 1 &&
                                        <div className="icon iq-action-icon-box rounded-circle" style={{ backgroundColor: '#3498db' }} >
                                            <span data-toggle="tooltip" data-placement="top" title="History" onClick={() => openhistoryInfo(item)}><i className="ri-eye-line" style={{ color: '#fff' }}></i></span>
                                        </div>
                                    }
                                </div>
                            }
                        </>
                }
            });

        } else {
            return [];
        }
    }, [filteredItems]);

    const dailyBulkActivation = () => {
        setPageNumber(1);
    }

    const backDailyBulkActivation = () => {
        setPageNumber(0);
    }

    const exportToCSV = async () => {
        if (dailyRequestResult.length <= 0) {
            alert('No data for export');
            return;
        }
        let id = 0;
        let formatData = dailyRequestResult && dailyRequestResult.length > 0 && dailyRequestResult.map((data, ind) => {
            let RequestedDtTm = moment(moment(data.RequestedDtTm).format('YYYY-MM-DD'));
            let currentDate = moment(moment().tz(process.env.REACT_APP_TIMEZONE).format('YYYY-MM-DD'));
            let diffInDays = currentDate.diff(RequestedDtTm, 'days');
            id = id + 1;
            let newData = {
                ID: id,
                'Creation Time': data.CreatedDtTm !== null ? moment(data.CreatedDtTm).tz(process.env.REACT_APP_TIMEZONE).format(process.env.REACT_APP_LONG_TIME_FORMAT) : '',
                'Dealer Name': data.DealerName,
                'Network Name': data.NetworkName,
                'Request Status': (diffInDays < 0 && data.RequestStatus != 13 ? 'Scheduled' : data.RequestStatusValue),
                AssignedTo: data.SimSwapID && data.SimSwapID !== null ? 'SIM Swap' : data.ActivationID && data.ActivationID !== null ? 'Activation' : '',
                IMEI: data.IMEI,
                'Serial Number': data.SerialNumber,
                MSISDN: data.RequestStatus === 12 ? data.MSISDN : '',
                'From Date': data.RequestedDtTm !== null ? moment(new Date(data.RequestedDtTm)).format(`${process.env.REACT_APP_DATE_FORMAT}`) : '',
                'To Date': data.RequestedToDate !== null ? moment(new Date(data.RequestedToDate)).format(`${process.env.REACT_APP_DATE_FORMAT}`) : '',
                Days: data.RequestedDays,
                'Sim Type': data.SimTypeValue,
                'Transaction ID': data.TransactionID,
                Email: data.CustomerEmailID,
                'Amount Charged': `$${data.AmountCharged.toFixed(2)}`,
                'Zip Code': data.AreaCode,
                Addon: data.ServiceName,
                Source: data.ActivationSource,
                CompletedBy: data.CompletedByName,
                Remark: data.Remark,
            }
            return newData
        })

        if (data && data.length > 0) {
            const ws = XLSX.utils.json_to_sheet(formatData);
            const wb = { Sheets: { 'dailyRequestResult': ws }, SheetNames: ['dailyRequestResult'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            await FileSaver.saveAs(data, 'Daily_Plan_Act' + fileExtension);
        }
    }

    return (
        <>
            {
                pageNumber === 1 ? <BulkDailyPlanActivation back={backDailyBulkActivation} searchData={searchData} /> :
                    <CardLayout title="Daily Acts Plan">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="form-row">
                                <div className="col-lg-2 col-md-4 mb-2">
                                    <label className='ml-2'> Network <span className='text-danger'>*</span></label>
                                    <select
                                        className="form-control"
                                        placeholder="Select Network"
                                        name="networkID"
                                        {...registerFilter("networkID", { required: 'Network is required !' })}
                                    >
                                        <option value="" disabled>Select</option>
                                        {networkResultData.length > 0 && networkResultData.map(network => (
                                            <option name="network" value={network.ID} key={network.ID}>
                                                {network.NetworkName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-2 col-md-4 mb-2">
                                    <label>Select Status</label>
                                    <select className="form-control" id="statusID" name="statusID" placeholder="Select"  {...registerFilter("statusID", {})}>
                                        {shortCodeResult && shortCodeResult.length > 0 && <option value="" name="All">All</option>}
                                        {shortCodeResult && shortCodeResult.length > 0 &&
                                            shortCodeResult.filter(item => item.ID !== 27 && item.ID !== 32 && item.ID !== 49).map((item, ind) => (<option key={item.ID} value={item.ID} selected={item.ID === 10}>{item.Value}</option>))
                                        }
                                    </select>
                                </div>

                                {
                                    (isAdmin(tokenData) || isAdminAgent(tokenData)) &&
                                    <div className="col-lg-2 col-md-4  mb-2">
                                        <label>Select Dealer</label>
                                        <select className="form-control" id="dealerID" name="dealerID"  {...registerFilter("dealerID", {
                                        })} >
                                            <option value="" name="All">All</option>
                                            {
                                                dealerResult && dealerResult.length && dealerResult.map((item) => {
                                                    return <option value={item.ID} key={`dealer${item.ID}`}>{item.DealerName}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                }

                                <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                                    <label>From Date</label>
                                    <Calendar2LineIcon onClick={openDatePicker} size={'1.5rem'} style={{ cursor: 'pointer', position: 'absolute', 'top': '36px', right: '12px', zIndex: 1 }} />
                                    <DatePicker
                                        ref={datePickerRef}
                                        selected={fromDate}
                                        className="form-control"
                                        onChange={(date) => setFromDate(date)}
                                        dateFormat="yyyy-MM-dd"
                                        name="fromDate"
                                        showMonthDropdown
                                        showYearDropdown
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                        value={fromDate}
                                    />
                                </div>

                                <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                                    <label>To Date</label>
                                    <Calendar2LineIcon onClick={openDatePicker2} size={'1.5rem'} style={{ cursor: 'pointer', position: 'absolute', 'top': '36px', right: '12px', zIndex: 1 }} />
                                    <DatePicker
                                        ref={datePickerRef2}
                                        selected={toDate}
                                        className="form-control center"
                                        onChange={(date) => setToDate(date)}
                                        dateFormat="yyyy-MM-dd"
                                        name="todate"
                                        showMonthDropdown
                                        showYearDropdown
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                        value={toDate}
                                    />
                                </div>

                                <div className="col-lg-2 col-md-4 mb-2">
                                    <label>SIM/Mobile/TXN</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="serialNumber"
                                        name="serialNumber"
                                        placeholder="SIM/Mobile/TXN"
                                        {...registerFilter("serialNumber")}
                                    />
                                </div>

                                <div className={(isAdmin(tokenData) || isAdminAgent(tokenData)) ? 'col-lg-2 col-md-4 mb-2' : 'col-lg-2 col-md-4'}>
                                    <div className={(isAdmin(tokenData) || isAdminAgent(tokenData)) ? "mt-2 d-flex justify-content-start activation-search-btn" : "mt-4"}>
                                        <Button title="Search" style="minWidth:80px" buttonClass={`btn btn-primary mt-1 btn-md Activity_searchBtn__GlBtC`} loading={buttonLoading} buttonType='submit' />
                                    </div>
                                </div>
                            </div>
                        </form>
                        <hr />
                        {(isAdmin(tokenData) || isAdminAgent(tokenData)) && (
                            <>
                                <PendingCountDealer />
                                <hr />
                            </>
                        )}

                        {showAlert && <Alert type={alertType} text={alertText} closeBtn={alertCancel} />}
                        <div className="row mb-3  ">
                            <div className='col-lg-3  activation-request-search-btn mb-sm-444'>
                                <SearchBar onFilter={handleFilterChange} filterText={filterText} />
                            </div>
                            <div className='col-lg-9 d-flex justify-content-end activation-request-action-btn '>
                                {tokenData && tokenData.length && tokenData[0].ParentID === 1 ? (
                                    <>
                                        <SideButtons
                                            title="Add Bulk Daily Plan"
                                            className="btn btn-success succ-btn-net font-weight-bold mr-2"
                                            onClick={() => dailyBulkActivation()}
                                        />
                                        <SideButtons
                                            title="Add Daily Plan"
                                            className="btn btn-primary succ-btn-net font-weight-bold mr-2"
                                            onClick={() => handleOpenAddFormModal()}
                                        />
                                    </>
                                ) : ''}
                                {dailyRequestResult.length > 0 && (
                                    <Button
                                        onClick={exportToCSV}
                                        title="Export"
                                        icon={<DownloadCloud2sLineIcon size={15} />}
                                        style="minWidth:120px"
                                        buttonClass="btn acti-export-btn-v acti-ex-btn ml-2 font-weight-bold text-white"
                                    />
                                )}
                            </div>
                        </div>

                        <div id={'DailyPlanRequestTable'}>
                            <Table columns={columns} data={data} loading={dailyRequestListLoading} pagination={true} />
                        </div>
                        <DailyPlanRequestForm searchData={searchData} />
                        {completeModal && <CompleteDailyPlanRequest completeModal={completeModal} handleCloseModal={handleCloseModal} row={row} searchData={searchData} />}
                        <CancelDailyPlanRequest transactionID={transactionID} cancelID={cancelID} searchData={searchData} />
                        {refundModal && <DailyPlanRefund modal={refundModal} row={row} close={closeDailyPlanRefundModal} search={searchData} />}
                        {refundInfoModal && <DailyPlanRefundDetails modal={refundInfoModal} row={row} close={closeShowRefundInfo} />}
                        {extendModal && <DailyPlanExtend modal={extendModal} row={row} close={closeExtendDaysModal} search={searchData} />}
                        {reduceModal && <DailyPlanReduce modal={reduceModal} row={row} close={closeReduceDaysModal} search={searchData} />}
                        {historyModal && <DailyPlanHistory modal={historyModal} row={row} close={closeHistoryModal} search={searchData} />}

                    </CardLayout>
            }
        </>
    )
}
const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
};

const modalStyle = {
    backgroundColor: "white",
    padding: "30px",
    borderRadius: "10px",
    boxShadow: "0px 4px 10px rgba(0,0,0,0.25)",
    textAlign: "center",
};

const buttonStyle = {
    marginTop: "20px",
    padding: "10px 20px",
    backgroundColor: "#dc3545",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
};

export default DailyActsPlan;